import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import reportWebVitals from './reportWebVitals';
import 'antd/dist/reset.css';
import {ConfigProvider} from 'antd';
import './index.css';
import dayjs from "dayjs";
import 'dayjs/locale/nl';
import AppLayout from "./Components/AppLayout";
import {BrowserRouter as Router} from "react-router-dom";
import {TranslationProvider} from "./lang";
import {AuthProvider} from "./auth";
import utc from 'dayjs/plugin/utc'
import relativeTime from 'dayjs/plugin/relativeTime'
import CookieConsent from "./Components/CookieConsent";
import nlBE from 'antd/locale/nl_BE';
import ChunkLoadFallback from './Components/ChunkLoadFallback';
import {beforeSend, shouldInitializeErrorReporting} from './errorReporting';
import {registerServiceWorker} from './serviceWorker';

if (shouldInitializeErrorReporting(window.location.hostname) && process.env.REACT_APP_BUGSINK_DSN) {
    Sentry.init({
        dsn: process.env.REACT_APP_BUGSINK_DSN,
        environment: process.env.REACT_APP_ENV || process.env.NODE_ENV,
        sendDefaultPii: false,
        tracesSampleRate: 0,
        beforeSend,
    });
}

dayjs.extend(utc)
dayjs.extend(relativeTime)


dayjs.locale("nl")

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <React.StrictMode>
        <Sentry.ErrorBoundary fallback={({error}) => <ChunkLoadFallback error={error}/>}>
            <AuthProvider>
                <TranslationProvider>
                    <ConfigProvider locale={nlBE} theme={{
                        token: {
                            colorBgBase: '#F9F4E8',
                            borderRadiusLG: '10px',
                            colorPrimary: '#006e2f',
                            colorLink: '#006e2f',
                            colorLinkHover: '#005724',
                        }
                    }}>
                        <Router>
                            <AppLayout/>
                            <CookieConsent/>
                        </Router>
                    </ConfigProvider>
                </TranslationProvider>
            </AuthProvider>
        </Sentry.ErrorBoundary>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Register service worker for PWA functionality (production only)
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
    window.addEventListener('load', () => {
        registerServiceWorker(navigator.serviceWorker);
    });
}
